import React, {Component} from 'react';
import { StyleSheet, css } from 'aphrodite';
import Transition from 'react-transition-group/Transition';
import Card from '../card/card';


const data = [
  {name: 'Pad Tracker',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737361/portfolio/padTracker.jpg',ghub: 'https://github.com/Momojunzi/padtracker2',link: 'https://padsapp.herokuapp.com/',desc: 'An inventory app made with React Node and Mongodb'},
  {name: 'Invitation',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1558064448/invitation_lu4ucf.jpg',ghub: 'https://github.com/Momojunzi/banquentrsvp',link: 'http://agentbanquet.herokuapp.com/',desc: 'An invitation for a company party'},
  {name: 'NY Times Search',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737362/portfolio/nytsearch.jpg',ghub: 'https://github.com/Momojunzi/nytreact',link: 'https://dry-lowlands-93203.herokuapp.com/',desc: 'Search the NY Times. Made with React Node and Mongodb '},
  {name: 'Wavepad',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737361/portfolio/wavepad.jpg',ghub: 'https://github.com/Momojunzi/wavepad',link: 'https://momojunzi.github.io/wavepad/',desc: 'A mobile oriented piano app made with vanilla JS and web audio api'},
  {name: 'Friend Finder',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737362/portfolio/friendfinder.jpg',ghub: 'https://github.com/Momojunzi/FriendFinder',link: 'https://obscure-castle-37227.herokuapp.com/',desc: 'See who you are compatible with. made with vanilla JS '},
  {name: 'Banquet App',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737363/portfolio/banquet.jpg',ghub: 'https://github.com/Momojunzi/banquet1',link: 'https://banquet1.herokuapp.com/',desc: 'An app to gather ideas for a company picnic. Made with React and Node'},
  {name: 'Color Game',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737362/portfolio/colorgame.jpg',ghub: 'https://github.com/Momojunzi/socketexperiment',link: 'https://dry-ravine-35632.herokuapp.com/',desc: 'A quick game to play on multiple devices at the same time. Made with React, Node and Socket.io'},
  {name: 'Eat a Burger',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737362/portfolio/burger.jpg',ghub: 'https://github.com/Momojunzi/sequelizedBurger',link: 'https://vast-plains-10818.herokuapp.com/',desc: 'An app to eat different burgers. Made with MySQL'},
  {name: 'Trivia Game',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737362/portfolio/triviagame.jpg',ghub: 'https://github.com/Momojunzi/TriviaGame',link: 'https://momojunzi.github.io/TriviaGame/',desc: 'A simple trivia game made with vanilla JS, HTML5, and CSS3'},
  {name: 'Hangman',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737362/portfolio/hangman.jpg',ghub: 'https://github.com/Momojunzi/Hangman-Game',link: 'https://momojunzi.github.io/Hangman-Game/',desc: 'A Game of Thrones themed hangman game. Made with JS, HTML5 and CSS3'},
  {name: 'Star Wars game',img: 'https://res.cloudinary.com/momojunzi/image/upload/v1537737361/portfolio/starwars.jpg',ghub: 'https://github.com/Momojunzi/week-4-game',link: 'https://momojunzi.github.io/week-4-game/',desc: 'A Star Wars themed role playing game. Made with JS, HTML5 and CSS3'}
]


class Work extends Component {
  state = {
    cards: [],
    asyncCards: []
  }

  componentDidMount() {
    this.createCards();
  }

  createCards = () => {
    const cards = data.map(project => {
      return (
        <Card dataObj={project}/>
      )
    })
    this.setState({cards, in: true}, ()=> {
      const cards = this.state.cards;
      const asyncCards = []
      let count = 0

        const interv = setInterval(()=> {
          asyncCards.push(this.state.cards[count])
          this.setState({asyncCards}, ()=> console.log(this.state.asyncCards))
          if(cards.length === asyncCards.length){
            clearInterval(interv);
          }
          count++
        }, 125)
    })
  }

  render() {
      return (
      <div className="row justify-content-between">
        {this.state.asyncCards}
      </div>
    )
  }
}

export default Work



// WEBPACK FOOTER //
// ./src/components/work/work.js